import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "./database-code";

/**
 * The category of transport
 */
export interface ActivityPeriodStatus extends DatabaseCode {
  stepValue: number;
}

const raw: ActivityPeriodStatus = {
  code: 'Raw',
  displayValue: {
    id: 'ots.ui.entity.activityperiod.status.raw',
    defaultMessage: 'Raw',
  },
  stepValue: 0,
};

const adminReviewed: ActivityPeriodStatus = {
  code: 'Admin Reviewed',
  displayValue: {
    id: 'ots.ui.entity.activityperiod.status.adminreviewed',
    defaultMessage: 'Admin Reviewed',
  },
  stepValue: 1,
};

const vendorEntered: ActivityPeriodStatus = {
  code: 'Vendor Entered',
  displayValue: {
    id: 'ots.ui.entity.activityperiod.status.vendorentered',
    defaultMessage: 'Vendor Entered',
  },
  stepValue: 2,
};

const adminComplete: ActivityPeriodStatus = {
  code: 'Admin Complete',
  displayValue: {
    id: 'ots.ui.entity.activityperiod.status.admincomplete',
    defaultMessage: 'Admin Complete',
  },
  stepValue: 3,
};

const operatorValidated: ActivityPeriodStatus = {
  code: 'Operator Validated',
  displayValue: {
    id: 'ots.ui.entity.activityperiod.status.operatorvalidated',
    defaultMessage: 'Operator Validated',
  },
  stepValue: 4,
};

const vendorApproved: ActivityPeriodStatus = {
  code: 'Vendor Approved',
  displayValue: {
    id: 'ots.ui.entity.activityperiod.status.vendorapproved',
    defaultMessage: 'Vendor Approved',
  },
  stepValue: 5,
};

const operatorCoded: ActivityPeriodStatus = {
  code: 'Operator Coded',
  displayValue: {
    id: 'ots.ui.entity.activityperiod.status.operatorcoded',
    defaultMessage: 'Operator Coded',
  },
  stepValue: 6,
};

export const activityPeriodStatus = {
  raw,
  adminReviewed,
  vendorEntered,
  adminComplete,
  operatorValidated,
  vendorApproved,
  operatorCoded,
};

export const activityPeriodStatuses = Object.values(activityPeriodStatus);

const getDefaultValue = (code: string | undefined): ActivityPeriodStatus | undefined => {
  if (!code) {
    return undefined
  }

  return {
    code: code,
    displayValue: {
      id: code,
      defaultMessage: code
    },
    stepValue: Infinity
  };
}

export const toActivityPeriodStatus = (code: string): ActivityPeriodStatus => toDatabaseCode(code, activityPeriodStatuses, getDefaultValue(code))

export const toActivityPeriodStatusSafely = (code: string | undefined, defaultValue: ActivityPeriodStatus | undefined = undefined): ActivityPeriodStatus | undefined => toDatabaseCodeSafely(code, activityPeriodStatuses, defaultValue)

